import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import './css/index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import Article from './Articles';
import Contact from './Contact';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <BrowserRouter>


  <Routes> 
  <Route path="/" element={<App />} />
  <Route path="/articles" element={<Article />} />
  <Route path="/contacts" element={<Contact />} />
  </Routes>

  </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
